import { Component } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { MatLegacyRadioChange as MatRadioChange } from '@angular/material/legacy-radio';
import { AuthenticationService } from '@app/core/authentication/authentication.service';
import { User } from '@app/shared/interfaces';
import { SettingsService, calculateSupportTier } from '@app/shared/services/settings/settings.service';
import { isAfter } from 'date-fns';
import { DialogSupportTierChangeComponent } from '../../components/dialog-support-tier-change/dialog-support-tier-change.component';

@Component({
  standalone: false,
  templateUrl: './support-tiers-page.component.html',
  styleUrls: ['./support-tiers-page.component.scss'],
})
export class SupportTiersPageComponent {
  user: User;
  loading = false;

  priorityPricing = {
    base_amount: null,
    per_property_amount: null,
  };

  selectedTier: 'basic' | 'premium' | 'vip';

  readOnly: boolean;
  public prioritySupportInGracePeriod = false;

  constructor(
    private auth: AuthenticationService,
    private dialog: MatDialog,
    private settingsService: SettingsService
  ) { }

  ngOnInit() {
    this.loading = true;
    this.settingsService.getPrioritySupportQuote().subscribe((quote) => {
      this.auth.getUserDetailsFromApi().subscribe((user) => {
        this.user = user;
        this.loading = false;
        this.prioritySupportInGracePeriod =
          this.user.priority_support.priority_support_ends_at !== null &&
          isAfter(this.user.priority_support.priority_support_ends_at, new Date());

        const hasPrioritySupport = this.user.priority_support.priority_support || this.prioritySupportInGracePeriod;

        this.selectedTier = calculateSupportTier(hasPrioritySupport, this.user.priority_support.priority_support_plan);

        this.readOnly = this.prioritySupportInGracePeriod || this.selectedTier === 'vip';
      });

      this.priorityPricing = {
        base_amount: quote.priority_support_base_addon_amount,
        per_property_amount: quote.priority_support_addon_amount_per_property,
      };
    });
  }

  changedTier(changeEvent: MatRadioChange) {
    this.selectedTier = changeEvent.value;
  }

  keepPrioritySupportModal() {
    const dialogRef = this.dialog.open(DialogSupportTierChangeComponent, {
      maxWidth: '100vw',
      maxHeight: '100vh',
      height: '100%',
      width: '100%',
      disableClose: false,
      data: {
        newPlan: 'keep-priority-support',
      },
    });

    dialogRef.afterClosed().subscribe((proceed) => {
      if (proceed) {
        this.loading = true;
        this.keepPrioritySupport();
      }
    });
  }

  keepPrioritySupport() {
    this.settingsService.upgradeToPrioritySupport().subscribe(() => {
      this.auth.getUserDetails(true);
      this.auth.getUserDetailsFromApi().subscribe(() => {
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      });
    });
  }

  saveChanges() {
    const dialogRef = this.dialog.open(DialogSupportTierChangeComponent, {
      maxWidth: '100vw',
      maxHeight: '100vh',
      height: '100%',
      width: '100%',
      disableClose: false,
      data: {
        newPlan: this.selectedTier,
      },
    });

    dialogRef.afterClosed().subscribe(() => {
      this.auth.getUserDetails(true);
      this.auth.getUserDetailsFromApi().subscribe(() => {
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      });
    });
  }
}
